<template>
  <div class="reports-index">
    <h3>Отчеты {{ tr[$route.params.type] }}</h3>
    <div class="create-new">
      <router-link :to="`/dashboard/reports/create/${$route.params.type}`" class="add-block">
        <el-button type="primary"> + Создать новый отчет</el-button>
      </router-link>
    </div>
    <div class="search-filter">
      <el-input placeholder="Поиск по номеру отчета" v-model="search" @input="searchInput" class="input-search">
        <el-button slot="append" icon="el-icon-search" @click="fetchReports"></el-button>
      </el-input>
      <div class="filter-worker">
        <el-select v-model="userSelect" placeholder="Выберите пользователя" @change="selectUser">
          <el-option
            v-for="(item, key) in options"
            :key="`${item.value}_${key}`"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="filter">
        <date-picker
          :editable="false"
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="datetimeRange"
          @change="changeDateTime"
          range
        ></date-picker>

      </div>
      <a
        @click="openDialog = true"
        class="filter-btn"
      >
        <el-button type="default">Выгрузить отчет</el-button>
      </a>
    </div>
    <div class="reports-ul">
      <router-link
        :to="`/dashboard/reports/create/${report.id}/${report.type}`"
        :key="`${report.id}_${key}`"
        class="reports-li" v-for="(report, key) in reports"
      >
        <div :class="['header-id', {'disabled': report.is_temp}]">
          <span>#{{ report.index }} {{ report.is_temp ? '(Не сохранен ...)' : ''}}</span>
          <span>{{ report.date }}</span>
        </div>
        <span>Пользователь: <strong>{{ report.user.name }}</strong></span>
        <span>Компания: <strong>{{ report.user.company }}</strong></span>
        <span v-if="$route.params.type !== 'WILD_PIPE'">Объект: <strong>{{ report.object }}</strong></span>
        <span v-else>Линия: <strong>{{ report.line && report.line.label }}</strong></span>
      </router-link>
    </div>


    <el-dialog
      @close="closeDialog"
      title="Выгрузить отчет"
      :visible.sync="openDialog"
      width="30%"
      center
    >
      <div v-if="$route.params.type !== 'JOB' || type_select">
        <div v-if="type_select === 'DAILY' || type_select === 'DAILY_PLAN'">
          <date-picker
            :editable="false"
            ref="datePicker"
            placeholder="Фильтр по дате"
            v-model="datetimeRangeDownload[0]"
          ></date-picker>
          <el-checkbox v-model="downloadForAll" style="margin-top: 10px">Все работы</el-checkbox>
        </div>
        <div v-else>
          <date-picker
            ref="datePicker"
            placeholder="Фильтр по дате"
            v-model="datetimeRangeDownload"
            range
          ></date-picker>
          <el-row>
            <el-col :span="12">
              <el-checkbox v-model="downloadForAll" style="margin-top: 10px">За все время</el-checkbox>
            </el-col>
            <el-col :span="12" v-if="$route.params.type === 'JOB' && this.$store.state.project.price">
              <el-checkbox v-model="downloadWithPrice" style="margin-top: 10px">Стоимость</el-checkbox>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-else style="display: flex; justify-content: center; flex-direction: column">
        <div style="margin-bottom: 10px; width: 100%">
          <el-button  style="width: 100%" @click="type_select = 'JOB'">Отчеты по работам</el-button>
        </div>
        <div style="margin-bottom: 10px; width: 100%">
          <el-button  style="width: 100%" @click="type_select = 'DAILY_PLAN'">Суточный отчет по планам</el-button>
        </div>
        <div style="width: 100%">
          <el-button style="width: 100%" @click="type_select = 'DAILY'">Суточный отчет</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="$route.params.type !== 'JOB' || type_select">
        <el-button @click="closeDialog">Закрыть</el-button>
        <a :href="getHref" target="_blank">
          <el-button type="primary" @click="closeDialog">Выгрузить</el-button>
        </a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import _ from 'lodash';
import {apiUrl} from '../../../plugins/firebase';
import {formatEndDate, formatStartDate} from "../../../utils/date";
import {getMyCompanyUsers} from "../../../firestore/permission";

export default {
  name: 'Index',
  components: {DatePicker},
  data() {
    return {
      openDialog: false,
      search: '',
      role: 'admin',
      userSelect: null,
      options: [],
      type_select: null,
      tr: {
        COVID: 'по температуре',
        PROF: 'по численности',
        TECH: 'по технике',
        JOB: 'по работам',
        MATERIALS: 'по материалам',
        MAIN: 'общий отчет',
        WILD_PIPE: 'по сварке трубопроводов',
      },
      datetimeRange: [
        new Date(String(dayjs().utc().subtract(10, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      downloadForAll: false,
      downloadWithPrice: false,
      datetimeRangeDownload: [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      reports: [],
    };
  },

  mounted() {
    if (this.$route.query.start) {
      this.datetimeRange = [
        new Date(String(this.$route.query.start)),
        new Date(String(this.$route.query.end)),
      ];
    } else if (this.$store.state.project.disableDate) {
      this.datetimeRange = [
        new Date(String(dayjs().subtract(365 * 10, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().format('YYYY-MM-DD'))),
      ];
    }

    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('users')
      .where('uid', '==', firebase.auth().currentUser.uid)
      .get().then(async (response) => {
      await response.forEach((sub) => {
        const data = sub.data();
        if (data) {
          this.role = data.role;
          this.loading = false;
        }
      });
      this.fetchReports();
      this.fetchUsers();
    });
  },

  watch: {
    '$route.query': {
      handler(response) {
        this.fetchReports();
      },
      deep: true,
    },
    type_select() {
      if (this.type_select === 'DAILY' || this.type_select === 'DAILY_PLAN') {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'day').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      } else {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      }
    }
  },

  methods: {
    searchInput: _.debounce(function (el, binding) {
      this.fetchReports();
    }, 500),
    closeDialog() {
      setTimeout(() => {
        this.openDialog = false;
        this.type_select = null;
        this.downloadWithPrice = false;
        this.downloadForAll = false;
      }, 10);
    },
    sliceJob(jobs) {
      if (this.$route.params.type === 'COVID') {
        return [
          jobs,
        ];
      } else {
        return jobs ? jobs.slice(0, 3) : [];
      }
    },
    selectUser() {
      let query = {
        ...this.$route.query,
      };
      if (!this.userSelect) {
        delete query.user;
      } else {
        query = {
          ...this.$route.query,
          user: this.userSelect,
        };
      }

      this.$router.push({
        path: this.$route.path,
        query: {
          ...query,
        },
      });
    },
    fetchUsers() {
      this.loader = true;
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .get()
        .then(async (data) => {
          const result = [{label: 'Все пользователи', value: null}];
          await data.forEach((subDoc) => {
            let _data = subDoc.data();
            result.push({label: _data.email + ' - ' + _data.name, value: _data.uid});
          });
          this.options = _.unionBy(result, 'label');

        }).finally(() => {
        this.loading = false;
      }).catch((e) => {
        this.loading = false;
      });
    },
    changeDateTime() {
      if (this.datetimeRange[0] && this.datetimeRange[1]) {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            start: dayjs(this.datetimeRange[0]).format('YYYY-MM-DD'),
            end: dayjs(this.datetimeRange[1]).format('YYYY-MM-DD'),
          },
        });
      } else {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            start: dayjs().subtract(10, 'days').format('YYYY-MM-DD'),
            end: dayjs().add(1, 'days').format('YYYY-MM-DD'),
          },
        });
      }
    },
    sendReport() {
      const proxy = firebase.functions().httpsCallable(`onGenerateLogCommonJobs/${this.$store.state.project.id}`);
      proxy().then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Отчет отправлен вам на почту',
          type: 'success',
        });
      }).catch(() => {
        this.$notify({
          offset: 60,

          title: 'Ошибка',
          message: 'Произошла ошибка, попробуйте позже',
          type: 'error',
        });
      });
    },
    navigate(report) {
      this.$router.push(
        `/dashboard/reports/edit/${report.id}/${this.$route.params.type}`,
      );
    },
    async fetchReports() {

      let query = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports');

      const filterArray = [
        ['type', '==', this.$route.params.type],
      ];

      if (this.search) {
        filterArray.push(
          ['index', '==', Number(this.search)],
        );
      }

      if (this.$route.query.user || this.$store.state.company.uid) {
        filterArray.push(
          ['userId', '==', this.$route.query.user || this.$store.state.company.uid],
        );
      }

      if (this.$route.query.start && this.$route.query.end) {
        filterArray.push(
          ['dateunix', '<', formatEndDate(this.$route.query.end)],
        );
        filterArray.push(
          ['dateunix', '>', formatStartDate(this.$route.query.start)],
        );
      } else {
        filterArray.push(
          ['dateunix', '<', formatEndDate(this.datetimeRange[1])],
        );
        filterArray.push(
          ['dateunix', '>', formatStartDate(this.datetimeRange[0])],
        );
      }

      if (this.role === 'worker') {
        filterArray.push(
          ['userId', '==', firebase.auth().currentUser.uid],
        );
      }

      query = filterArray.reduce((accQuery, filter) => {
        return accQuery.where(filter[0], filter[1], filter[2]);
      }, query).orderBy('dateunix', 'desc');


      query.get()
        .then(async (data) => {
          const result = [];
          this.reports = [];
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              ...data,
              index: data.index,
              id: subDoc.id,
              object: data.object && data.object.name,
              date: dayjs(data.datetime.substring(0, data.datetime.indexOf('+'))).format('DD/MM/YY'),
              jobs: data.jobs,
            });
          });

          if (this.role === 'editor') {
            const usersIds = await getMyCompanyUsers(this.$store.state.project.id);
            this.reports = result.filter((r) => usersIds.includes(r.userId));
          } else {
            this.reports = result;
          }
        });
    },
  },
  computed: {
    getHref() {
      const types = {
        'JOB': 'onGenerateFactJobs',
        'PROF': 'onGenerateHeadcount',
        'TECH': 'onGenerateTechnical',
        'COVID': 'onGenerateTemperature',
        'WILD_PIPE': 'onGenerateWelding',
        'MATERIALS': 'onGenerateMaterial',
        'MAIN': 'onGenerateMainJobs',
        'DAILY_PLAN': 'onGenerateDailyJobs',
        'DAILY': 'onGenerateDailyReportsJobs',
        'PRICE': 'onGeneratePriceJobs',
      };


      let path = types[this.type_select === 'DAILY' ? 'DAILY' : (this.$route.params.type || 'JOB')]

      if (this.downloadWithPrice) {
        path = types['PRICE'];
      }

      if(this.type_select === 'DAILY_PLAN') {
        path = types['DAILY_PLAN']
      }

      let url = `${apiUrl}/${path}/${this.$store.state.project.id}?uid=${firebase.auth().currentUser.uid}`;
      if (!this.downloadForAll && this.type_select !== 'DAILY') {
        url += `&fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}&toDate=${dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')}`;
      } else if (this.type_select === 'DAILY' || this.type_select === 'DAILY_PLAN') {
        url += `&fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}`;
      }

      return url;
    },
  },
};
</script>

<style scoped lang="scss">
.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.input-search {
  margin-top: 10px;
}

.reports-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  cursor: pointer;
  padding: 10px 14px;
  text-decoration: none;
  color: #000;

  .header-id {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    width: 100%;
  }

  span {
    font-size: 14px;
    color: #2c3e50;
  }

  span:first-child {
    margin-right: 20px;
  }


  span {
    margin-right: 5px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

> > > .el-date-editor--daterange.el-input__inner {
  width: 100%;
  margin-top: 10px;
}

.add-block {
  button {
    width: 100%;
    margin-top: 10px;
  }
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 260px;

  .input-search {
    margin-right: 10px;
    min-width: 260px;
  }

  .filter-btn {
    margin-top: 10px;
    margin-left: 10px;
  }
}

.create-new {
  display: flex;
  justify-content: flex-start;
  flex: 1;
}

.jobs-list {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 764px) {
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: 100%;

    .el-select {
      width: 100%;
    }
  }
}

.create-new {
  display: flex;
  justify-content: space-between;
}

.filter {
  min-width: 260px;
}

.filter-worker {
  min-width: 200px;
  margin-top: 10px;
  margin-right: 5px;
}

> > > .mx-datepicker-range {
  width: 100%;
  margin-top: 10px;

  .mx-input {
    border: 1px solid #DCDFE6;
    height: 40px;
  }
}

.disabled {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/Type.vue